import { toUserMessage } from 'utils/apiErrorHelper';
import { api } from '../../DefaultService';
import type { IPaginationParams } from '../../types';
import type { IRecognitionFilterParams } from '../types';
import type {
  IGeneralRecognitionCreateProps,
  IGeneralRecognitionProps,
  IGeneralRecognitionSimpleProps,
  IGeneralRecognitionUpdateParams,
} from './types';

const ENDPOINT = 'v1/recognitions/general';

const formatApiError = (error: any): Error => {
  return new Error(toUserMessage(error));
};

export const createGeneralRecognitionAsync = async (
  data: IGeneralRecognitionCreateProps,
): Promise<IGeneralRecognitionProps> => {
  try {
    const response = await api.post(`${ENDPOINT}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const updateGeneralRecognitionAsync = async ({
  id,
  data,
}: IGeneralRecognitionUpdateParams): Promise<IGeneralRecognitionProps> => {
  try {
    const response = await api.put(`${ENDPOINT}/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getGeneralRecognitionByIdAsync = async (
  id: number,
): Promise<IGeneralRecognitionProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const getAllGeneralByLicenseAsync = async (
  pagination?: IPaginationParams,
  filter?: IRecognitionFilterParams,
): Promise<IGeneralRecognitionSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};
